<template>
  <div class="topciver">
     <div class="topLeft">
        <span class="topLeft_tit">县域面积</span>
        <span class="topLeft_Num"> <span class="topLeft_NumShow">1987</span>平方公里 </span>
     </div>
     <div class="topLeft">
        <span class="topLeft_tit">下辖地区</span>
        <span class="topLeft_Num"> <span class="topLeft_NumShow">22</span>镇 <span class="topLeft_NumShow" style="margin-left:5%;">8</span>乡 </span>
     </div>
  </div>
</template>
 
<script>
export default {
  name: 'Xianyu',
  data () {
    return {
    }
  },
  created(){
    
  },
   mounted() {
    
  },
  methods:{

  }
}
</script>

<style  scoped>
.topciver{
    width: 500px;
    position: absolute;
    top: 10vw;
    left: 36.5%;
    z-index: 6;
}
.topLeft {
    width: 230px;
    height: 3.1vw;
    background: url(../assets/images/topImg.png) no-repeat;
    background-size: 100% 100%;
    float: left;
    margin-right: 20px;
}
.topLeft_tit{
    color: #fff;
    display: block;
    line-height: 1px;
    font-size: 16px;
    font-weight: bold;
}
.topLeft_Num{
    font-size: 16px;
    color: #DBED44;
    display: block;
    margin-top: 14px;
}
.topLeft_NumShow{
    font-size: 30px;
    font-family: UnidreamLED;
    margin-right: 3%;
}
</style>